



















































































import { Component, Watch, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { ListType } from '@/util/types'
import { courseItem, resourceItem } from '@/api/res'
import { fetchClientStatus, fetchList } from './data'
import {
  TestPoint,
  TestingPointDes,
  PersonalPoint,
  TestClassInfo,
  StudentLabel
} from '@/components/studyData'
import { parse } from 'qs'
import { post, get } from '@/fn/ajax'
import { Tooltip, Modal, message } from 'ant-design-vue'

@Component({
  components: {
    TestPoint,
    TestingPointDes,
    PersonalPoint,
    TestClassInfo,
    StudentLabel
  }
})
export default class StudyData extends ViewBase {
  @Prop({ default: null }) playStatus!: any
  @Prop({ default: null }) reviewId!: any
  @Prop({ default: null }) resId!: any

  lang: any = {}

  doc: any

  choseStudent: any = 0

  studentList: any = []

  steps: any = {}

  personalProcess: any = {}

  points: any = {}

  pointPicData: any = null

  loading: boolean = true

  refresh: any = null

  onceInt: any = true

  time: number = 0

  showStudentInfo: boolean = false

  showStudentId: any = ''

  columns: any = []

  data: any = []

  studentsNumber: any = {}

  studentStatistical: any = []

  pointsStatistical: any = []

  levelStatistical: any = []

  studentInfoData: any = []

  get i18n() {
    const value = this.$t('login')
    return value as any
  }
  get isEnLang() {
    return this.$i18n.locale == 'en'
  }
  async setStudentInfo() {
    this.columns = [
      {
        title: this.i18n.vClients.learnList,
        dataIndex: 'p_desc'
      },
      {
        title: this.i18n.vClients.controlInfo,
        width: '100px',
        dataIndex: 'status',
        align: 'center',
        scopedSlots: { customRender: 'status' }
      }
    ]

    const pdata: any = {
      reviewId: this.reviewId,
      student_id: this.showStudentId
    }
    const res = await post('/api/play/studentReviewData', pdata)
    this.studentInfoData = res.data
  }
  async fetch() {
    this.loading = true
    const pdata: any = {}
    if (this.reviewId && this.reviewId != '') {
      pdata.reviewId = this.reviewId
      // pdata.resId = this.resId
      // if (this.choseStudent != 0) {
      //   pdata.cid = this.choseStudent
      // }
      try {
        const res = await post('/api/play/reviewData', pdata)
        if (res && res.data) {
          this.setContent(res.data)
        }
        // message.success(this.i18n.uHeader.operationSuccess)
      } catch (ex) {
        message.error(String(ex))
      }
    } else {
      this.loading = false
    }
  }

  showStudent(item: any) {
    if (item.status != 3) {
      this.showStudentId = item.student_id
      this.setStudentInfo()
      this.showStudentInfo = true
    }
  }

  closeStudentInfo() {
    this.showStudentInfo = false
  }

  setContent(data: any) {
    this.studentsNumber = data.students_number
    this.studentStatistical = data.student_statistical
    this.pointsStatistical = data.points_statistical
    this.levelStatistical = data.level_statistical
    this.loading = false
    this.onceInt = false
    this.time++
  }

  created() {
    this.lang = this.i18n.vStudy
    this.doc = window.document
    this.fetch()
    const chapterId = this.$store.state.playInfo.chapterId
    const playId = this.$store.state.playInfo.id
    if (chapterId == 2 && this.playStatus != 'Play' && this.resId == playId) {
      clearInterval(this.refresh)
      this.refresh = setInterval(() => {
        this.fetch()
      }, 5000)
    }
  }
  beforeDestroy() {
    clearInterval(this.refresh)
  }
  @Watch('playStatus')
  watchPlayStatus(info: any) {
    if (this.resId == this.$store.state.playInfo.id && info != 'Play') {
      clearInterval(this.refresh)
      this.refresh = setInterval(() => {
        this.fetch()
      }, 5000)
    } else {
      clearInterval(this.refresh)
    }
    // console.log(info)
  }
  @Watch('id')
  watchId(value: any) {
    this.fetch()
    if (this.resId == this.$store.state.playInfo.id && this.playStatus != 'Play') {
      clearInterval(this.refresh)
      this.refresh = setInterval(() => {
        this.fetch()
      }, 5000)
    } else {
      clearInterval(this.refresh)
    }
  }
}
